var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showComponent.length > 0)?[(_vm.showComponent.includes('ketshop'))?[_c('v-container',[_c('ketshop-setting')],1)]:_vm._e()]:[_c('div',{staticClass:"text-xs-center my-4"},[_vm._v("No integration available")])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-248e4b9e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/billing/Plugin.vue
// module id = null
// module chunks = 